import { Component, OnInit } from "@angular/core";
import { environment } from "../../../../../../environments/environment";

@Component({
  selector: "app-sidebar-footer",
  templateUrl: "./sidebar-footer.component.html",
  styleUrls: ["./sidebar-footer.component.scss"],
  standalone: false,
})
export class SidebarFooterComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
